import React from 'react';
import SideBar from './SideBar';
import TopBar from './TopBar';
// import '../css/style.css';
import { connect } from 'react-redux';

const mapState = state => ({
    userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({

});

class MainLayout extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // When page is fully loaded
        window.App.initCore();
        window.App.initAfterLoad();
    }

    render() {
        return (
            <React.Fragment>
                <TopBar/>
                <SideBar/>
                <div className="page-content">
                    <div className="content-wrapper">
                        <div className="content">
                            {this.props.children}
                        </div>

                        <div className="navbar navbar-expand-lg navbar-light">
                            <div className="text-center d-lg-none w-100">
                                <button type="button" className="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-footer">
                                    <i className="icon-unfold mr-2"></i> Footer
                                </button>
                            </div>

                            <div className="navbar-collapse collapse" id="navbar-footer">
                                <span className="navbar-text">
                                    &copy; 2015 - 2020 - Công ty cổ phần Công Nghệ Tadu - <a href="http://tadu.cloud" target="_blank">Tadu.cloud</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(mapState, mapDispatch)(MainLayout);
